import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, Response, ResponseContentType } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { HttpConst } from '../core/resources/http/http.const';
import { TokenKey } from '../core/service/tokenKey';
import { HttpClientModule, HttpClient, HttpHeaders, HttpResponse, HttpParams  } from '@angular/common/http'; // MOD EXP(CFJC) 20210519 REQ19649

@Injectable()
export class BaseService {
  // INI EXP(CFJC) 20210519 REQ19649
  private pdfHttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/pdf',
    'X-Xss-Protection': '1'
  });
  private httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'X-Xss-Protection': '1'
  });
  // FIN EXP(CFJC) 20210519 REQ19649
  constructor(private https: HttpClient) { }

  httpGet(url: string, params?: HttpParams, isNew?: boolean): Promise<Response> | Observable<any> { // MOD EXP(CFJC) 20210519 REQ19649
    if (isNew) { // ADD EXP(CFJC) 20210519 REQ19649
      return this.https.get(url, { headers: this.httpHeaders, params: params }); // ADD EXP(CFJC) 20210519 REQ19649
    } else { // ADD EXP(CFJC) 20210519 REQ19649
      return this.https.get(url, this.obtenerEncabezadoHttp())
        .toPromise()
        .then(this.recuperarDatos).catch(this.controlarError);
    } // ADD EXP(CFJC) 20210519 REQ19649
  }

  httpGetArchivo(url: string): Promise<Response> {
    return this.https.get(url, this.obtenerEncabezadoHttpArchivo())
      .toPromise()
      .then(this.recuperarArchivo).catch(this.controlarError);
  }
  //INI EXP(GVASQUEZ) 20240110 - REQ37988
  // Nuevo metodo para el servicio API_BANK
  async httpGetArchivoExterno(url: string): Promise<Response> {
    return await this.https.get(url, { headers: new HttpHeaders({
      'AccessKeyBanTotal': 'mafban2022$'
    }), responseType: 'blob' as 'json'}).toPromise()
      .then(this.recuperarArchivo).catch(this.controlarError);
  }
  //FIN EXP(GVASQUEZ) 20240110 - REQ37988

  httpGetNonSecure(url: string): Promise<Response> {
    return this.https.get(url, this.obtenerEncabezadoHttpNonSecure())
      .toPromise()
      .then(this.recuperarDatos).catch(this.controlarError);
  }

  httpPost<TSource, TResult>(url: string, data: TSource, isNew: boolean): Observable<TResult>;  // ADD EXP(CFJC) 20210519 REQ19649
  httpPost(url: string, data: any, isNew?: boolean) : Promise<Response>; // MOD EXP(CFJC) 20210519 REQ19649
  httpPost<TSource, TResult>(url: string, data: any|TSource, isNew: boolean = false): Promise<Response> | Observable<TResult> { // ADD EXP(CFJC) 20210519 REQ19649
    if (isNew) { // ADD EXP(CFJC) 20210519 REQ19649
      return this.https.post<TResult>(url, data, { headers: this.httpHeaders }); // ADD EXP(CFJC) 20210519 REQ19649
    } else { // ADD EXP(CFJC) 20210519 REQ19649
      return this.https.post(url, JSON.stringify(data), this.obtenerEncabezadoHttp())
        .toPromise()
        .then(this.recuperarDatos).catch(this.controlarError);
    } // ADD EXP(CFJC) 20210519 REQ19649
  }
//INI INE(JJGJ) 20221018 - REQ22978
  httpPostFile(url: string, form: any) : Promise<any> {
    return this.https.post(url,form).toPromise().then(this.recuperarDatos).catch(this.controlarError);
  }
  //FIN INE(JJGJ) 20221018 - REQ22978

  // INI EXP(CFJC) 20210519 REQ19649
  httpPostToGetFile<T>(url: string, body: T) {
    return this.https.post(url, body, { headers: this.pdfHttpHeaders, responseType: 'blob' });
  }

  httpPut<TBody, TResult>(url: string, body: TBody) {
    return this.https.put<TResult>(url, body, { headers: this.httpHeaders });
  }


  // FIN EXP(CFJC) 20210519 REQ19649

  httpPostNonSecure(url: string, data: any): Promise<Response> {
    return this.https.post(url, JSON.stringify(data), this.obtenerEncabezadoHttpNonSecure())
      .toPromise()
      .then(this.recuperarDatos).catch(this.controlarError);
  }

  recuperarDatos(response: any) {
    let resultado: any;
    const retorno = response;
    resultado = retorno;
    return resultado;
  }

  recuperarArchivo(response: any) {
    let resultado: any;
    const retorno = response;
    resultado = retorno;
    return resultado;
  }

  checkIsLogin() {
    return true;
  }

  checkIsLoginToken() {

    return true;
  }

  grabarKeyApp(parametro: any) {

  }

  obtenerKeyApp(): any {
    return null;
  }

  controlarError(error: Response | any) {
    if (error.status === 401) {
      localStorage.clear();
      location.href='/';
      //alert('error 401');
    }else{
      //console.log('Aqui error');
      console.error(error.message || error);
    }
    return Promise.reject(error.message || error);
  }

  obtenerEncabezadoHttpArchivo(): any{
    const options = 
    {
      headers : new HttpHeaders({
      'Content-Type':  'application/json',
      'Accept':  'application/pdf',
      'X-Xss-Protection':'1'
    }) , 
    responseType: 'blob' as 'blob'
  };
  return options;
  }
  //INI EXP(GVASQUEZ) 20240110 - REQ37988
  //Nuevo método para el encabezado del servicio API_BANK
  obtenerEncabezadoHttpArchivoEx(): any{
    const options = 
    {
      headers : new HttpHeaders({
      'Content-Type':  'application/json',
      'Accept':  'application/pdf',
      'X-Xss-Protection':'1',
      'AccessKeyBanTotal': 'mafban2022$'
    }) , 
    responseType: 'blob' as 'blob'
  };
  return options;
  }
  //FIN EXP(GVASQUEZ) 20240110 - REQ37988

  obtenerEncabezadoHttp(): any{
    const options = 
    {
      headers : new HttpHeaders({
      'Content-Type':  'application/json',
      'X-Xss-Protection':'1'
    })
  };
  return options;
  }

  obtenerEncabezadoHttpNonSecure(): any{
    const options = 
    {
      headers : new HttpHeaders({
      'Content-Type':  'application/json',
      'X-Xss-Protection':'1'
    })
  };
  return options;
  }
}
